export class ApplicationStatuses {
  static DRAFT = 'draft'
  static AWAITING = 'awaiting'
  static CONFIRMED = 'confirmed'
  static EXECUTED = 'executed'
  static DISCARD = 'discard'

  /**
   * Is status1 less than status2
   * @param {string} status1
   * @param {string} status2
   */
  static compare (status1, status2) {
    const statusesOrder = [
      ApplicationStatuses.DRAFT,
      ApplicationStatuses.AWAITING,
      ApplicationStatuses.CONFIRMED,
      ApplicationStatuses.EXECUTED,
      ApplicationStatuses.DISCARD
    ]

    return statusesOrder.indexOf(status1) < statusesOrder.indexOf(status2)
  }
}
